module.exports = __webpack_public_path__ + "img/phonepe1.e16d57f9.png";